import { AuditResponse, CompanyProfile } from '@shared/types'

import { useQuery } from 'react-query'

import { apiJSON } from '@shared/utils/api/api.util'

export const useAuditQuery = (
  isPreview: boolean,
  companyID: number,
  auditID?: number
) => {
  const {
    data: companyProfile,
    isLoading: isLoadingCompanyProfile,
    isFetching: isFetchingCompanyProfile,
    refetch: refetchCompanyProfile,
  } = useQuery<CompanyProfile>(
    `CompaniesEvaluationProfiles/${companyID}`,
    () => apiJSON(`CompaniesEvaluationProfiles/${companyID}`),
    {
      enabled: isPreview && !!companyID,
    }
  )

  const {
    data: audit,
    isLoading: isLoadingAudit,
    isFetching: isFetchingAudit,
    refetch: refetchAudit,
  } = useQuery<AuditResponse>(
    `companies/${companyID}/audits/${auditID}`,
    () => apiJSON(`companies/${companyID}/audits/${auditID}`),
    {
      enabled: !isPreview && !!companyID && !!auditID,
    }
  )

  return {
    companyProfile,
    audit,
    isLoading: isLoadingCompanyProfile || isLoadingAudit,
    isFetching: isFetchingCompanyProfile || isFetchingAudit,
    refetch: isPreview ? refetchCompanyProfile : refetchAudit,
  }
}
